import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useMaintenance } from "../../hooks/useMaintenance";

import HorizontalRule from "../../components/Rule/Horizontal";
import CommonButton from "../../components/Button";
import { MyProfileKakaoIcon } from "../MyInfo";

import SandiCI from "../../assets/img/sandi-ci-simple.png";
import MaintenanceCI from "../../assets/img/maintenance.png";

type Props = {};

export default function Maintenance(props: Props) {
  const navigate = useNavigate();

  const [maintenance, checkMaintenance] = useMaintenance();

  useEffect(() => {
    checkMaintenance().then((isMaintenance) => {
      if (!isMaintenance) {
        navigate("/auth/login");
      }
    });
  }, []);

  return maintenance.isMaintenance ? (
    <div className="relative flex flex-col min-h-screen min-w-screen justify-center px-5">
      <div className="flex flex-col justify-center items-center gap-5">
        <img src={SandiCI} className="h-[40px]" />
        <img src={MaintenanceCI} className="h-[160px]" />
        <div className=" text-brand-primary-magenta text-[30px] font-semibold text-center">
          시스템 점검중입니다
        </div>
        <HorizontalRule margin="0" className="w-[90px] bg-black" />
        <div className="flex flex-col gap-5 text-center text-base font-medium">
          <div className="flex flex-col gap-2.5 whitespace-pre-line">
            {maintenance.message}
            <div>{`서비스 이용에 불편을 드려 죄송합니다.`}</div>
          </div>
          <div className="py-5 flex flex-col gap-2.5 bg-[#f7f7f7] items-center">
            <div className="whitespace-pre-line text-center text-brand-neutral-80 text-sm">
              {"관련사항은 카카오톡으로 문의해 주세요."}
            </div>
            <a href="https://pf.kakao.com/_xhJxkZK/chat">
              <CommonButton
                variant="transparent"
                className="!bg-[#fee500] w-fit px-4 py-3 text-sm text-black font-medium"
              >
                <MyProfileKakaoIcon />
                카카오톡 문의
              </CommonButton>
            </a>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}
